import { useTranslation } from 'next-i18next'
import { isAfterpayInAppBrowser } from '../../utils/device'
import { useCountry, useExperiment } from '../../state'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { BASE_PATH } from '../../env'
import { Heading, Text } from '@afterpaytouch/core'
import styles from './style.module.css'
import { TrackingEvent } from '../../model/monitoring'
import Image from 'next/image'
import React from 'react'
import { Country } from '@afterpay/types'

export const SocialBannerUk = (): JSX.Element | null => {
  const { t } = useTranslation()
  const isAppSession = isAfterpayInAppBrowser()
  const experiment = useExperiment('CheckoutSocialProofExperimentUk', !isAppSession)
  const country = useCountry()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleBannerOnClick = (): void => {
    logEvent(TrackingEvent.PRESSED_SOCIAL_BANNER_UK)
  }

  if (isAppSession || country !== Country.GB || experiment?.value !== 'A') {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.banner} onClick={handleBannerOnClick}>
        <div className={styles.left}>
          <Heading size='M'>{t('login:socialBannerUk.heading')}</Heading>
          <Heading size='M'>{t('login:socialBannerUk.heading2')}</Heading>
          {
            <Text size='XS' color='Gray10'>
              {t('login:socialBannerUk.subHeading')}
            </Text>
          }
          <div className={styles.tipsContainer}>
            <Text size='XXS' color='Gray50'>
              {t('login:socialBannerUk.tips')}
            </Text>
          </div>
        </div>
        <div className={styles.right}>
          <Image
            src={`${BASE_PATH}/images/${t('login:socialBannerUk.imgSrc')}`}
            alt=''
            width={106}
            height={81}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </div>
      </div>
    </div>
  )
}
